import { createContext, useContext } from "react";

export const ModalContext = createContext({
    openConnect: () => {},
    openEstimator: () => {},
});

export const useModals = () => useContext(ModalContext);
